import { getWindowObject } from './get-window-object';

declare global {
    interface Window {
        FormData?: typeof FormData;
    }
}

/**
 * Safely check if the window exists and supports form data
 */
export const HAS_FORM_DATA = !!getWindowObject('FormData');
